<template>
    <div class="row border-radius bg-white padding-flex mb-1">
        <div class="col-md-12 estate-energy-data">
            <div class="row">
                <div class="col-auto"><img  src="/img/logo/logo_tag.svg" width="60"/></div>
                <div class="col">
                    <!-- {{trans('labels.desc_tag') | capitalize }}   -->
                    <span v-html="trans('labels.desc_tag')"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        estate: {
            type: Object,
            required: true,
        },
    },

    computed: {

        lang() {
            return this.$root.lang.estate_detail
        },
    },
}
</script>